import { Component, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { JhiEventManager, JhiAlert, JhiAlertService } from 'app/ng-jhipster/service';
import { Subscription } from 'rxjs';
import { AlertHelperService } from '../util/alert-helper.service';

@Component({
  selector: 'jhi-alert-error',
  template: `
    <div class="alerts" role="alert">
      @for (alert of alerts; track alert) {
        <div [ngClass]="setClasses(alert)">
          @if (alert && alert.type && alert.msg) {
            <ngb-alert [type]="alert.type" (close)="alert.close(alerts)">
              <pre [innerHTML]="alert.msg"></pre>
            </ngb-alert>
          }
        </div>
      }
    </div>
  `,
  standalone: false,
})
export class JhiAlertErrorComponent implements OnDestroy {
  alerts: any[];
  cleanHttpErrorListener: Subscription;
  constructor(
    private alertService: JhiAlertService,
    private eventManager: JhiEventManager,
    private translateService: TranslateService,
    private alertHeplper: AlertHelperService,
  ) {
    this.alerts = [];

    this.cleanHttpErrorListener = eventManager.subscribe('finitoApp.httpError', response => {
      let i;
      const httpErrorResponse = response.content;
      switch (httpErrorResponse.status) {
        // connection refused, server not reachable
        case 0:
          this.addErrorAlert('Server not reachable', 'error.server.not.reachable');
          break;

        case 400: {
          const arr = httpErrorResponse.headers.keys();
          let errorHeader = null;
          let entityKey = null;
          arr.forEach(entry => {
            if (entry.toLowerCase().endsWith('app-error')) {
              errorHeader = httpErrorResponse.headers.get(entry);
            } else if (entry.toLowerCase().endsWith('app-params')) {
              entityKey = httpErrorResponse.headers.get(entry);
            }
          });
          if (entityKey != null && entityKey.includes('@@@@@')) {
            const resEntityKey = entityKey.split('@@@@@');
            this.addInfoNotification(resEntityKey[0], resEntityKey[0], { entityName: resEntityKey[1] });
          } else if (entityKey != null && entityKey.includes('#####')) {
            const resEntityKey = entityKey.split('#####');
            this.addErrorAlert(resEntityKey[0], resEntityKey[0], { entityName: resEntityKey[1] });
          } else {
            if (errorHeader) {
              let entityName = '';
              if (entityKey.length > 3 && entityKey.substring(0, 3) === 'ID-') {
                entityName = entityKey.substring(3);
              } else {
                entityName = translateService.instant('global.menu.entities.' + entityKey);
              }

              this.addErrorAlert(errorHeader, errorHeader, { entityName });
            } else if (httpErrorResponse.error !== '' && httpErrorResponse.error.fieldErrors) {
              const fieldErrors = httpErrorResponse.error.fieldErrors;
              for (i = 0; i < fieldErrors.length; i++) {
                const fieldError = fieldErrors[i];
                if (['Min', 'Max', 'DecimalMin', 'DecimalMax'].includes(fieldError.message)) {
                  fieldError.message = 'Size';
                }
                // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                const convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                const fieldName = translateService.instant('finitoApp.' + fieldError.objectName + '.' + convertedField);
                this.addErrorAlert('Error on field "' + fieldName + '"', 'error.' + fieldError.message, { fieldName });
              }
            } else if (httpErrorResponse.error !== '' && httpErrorResponse.error.message) {
              this.addErrorAlert(httpErrorResponse.error.message, httpErrorResponse.error.message, httpErrorResponse.error.params);
            } else {
              this.addErrorAlert(httpErrorResponse.error);
            }
          }
          break;
        }
        case 404:
          this.addErrorAlert('Not found', 'error.url.not.found');
          break;

        default:
          if (httpErrorResponse.error !== '' && httpErrorResponse.error.message) {
            this.addErrorAlert(httpErrorResponse.error.message);
          } else {
            this.addErrorAlert(httpErrorResponse.error);
          }
      }
    });
  }

  setClasses(alert) {
    return {
      'jhi-toast': alert.toast,
      [alert.position]: true,
    };
  }

  ngOnDestroy() {
    if (this.cleanHttpErrorListener !== undefined && this.cleanHttpErrorListener !== null) {
      this.eventManager.destroy(this.cleanHttpErrorListener);
      this.alerts = [];
    }
  }

  addErrorAlert(message, key?, data?) {
    message = key && key !== null ? key : message;
    const newAlert: JhiAlert = {
      type: 'danger',
      msg: message,
      params: data,
      timeout: 600000,
      toast: this.alertService.isToast(),
      scoped: true,
    };
    this.alerts.push(this.alertService.addAlert(newAlert, this.alerts));

    this.alertHeplper.scrollToAlert();
  }

  addInfoNotification(message, key?, data?) {
    message = key && key !== null ? key : message;
    const newAlert: JhiAlert = {
      type: 'success',
      msg: message,
      params: data,
      timeout: 600000,
      toast: this.alertService.isToast(),
      scoped: true,
    };
    this.alerts.push(this.alertService.addAlert(newAlert, this.alerts));

    this.alertHeplper.scrollToAlert();
  }
}
